<div class="row baner-superior justify-content-center  m-0">
  <div class="col-2">
    <i class="bi bi-list menubtn" (click)="toogleMenu();"></i>
  </div>
  <div class="col-10">
    <img src="assets/imagenes/logo_horizontal.png" alt="Tecnopista" class="logoClass">
  </div>
</div>
